import React, { ChangeEvent } from 'react';
import {
  TextField,
  OutlinedTextFieldProps,
  Box,
  Typography,
} from '@mui/material';

interface InputDefaultProps extends OutlinedTextFieldProps {
  onChangeData?: (field: string, value: string) => void;
  labelName?: string;
}

export const InputDefault: React.FC<InputDefaultProps> = ({
  onChangeData,
  size = 'small',
  labelName = '',
  variant = 'outlined',
  ...rest
}) => {
  const onChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    if (onChangeData) onChangeData(event.target.name, event.target.value);
  };

  return (
    <Box>
      {labelName && <Typography>{labelName}</Typography>}
      <TextField
        size={size}
        fullWidth
        onChange={onChange}
        color={'success'}
        variant={variant}
        InputLabelProps={{
          shrink: true,
          style: { fontSize: 19 },
        }}
        inputProps={{
          style: {
            height: 30,
          },
        }}
        {...rest}
      />
    </Box>
  );
};
